'use strict';
import angular from 'angular';
import './scripts/iomaster.services';

angular.module('core.iomaster', [
    'iomaster.services'
]);